import $ from 'jquery';
import addToBag from './add-to-bag';
import logEngagement from '../../modules/log-engagement';

function manageElementsVisibility($form, isPDP) {
    $form.find('.js-notification-r-in-stock').hide();
    $form.find('.js-shop-revolve-instock').hide();
    if (isPDP) {
        $form.find('.js-oos-special-order').show();
        $form.find('.js-oos-notify-me').hide();
    }
}

function isAddToBag(formObj){
    return formObj.find('.js-add-to-bag').is(':visible');
}

function isNotifyMe(formObj){
    return formObj.find('.js-notify-me').is(':visible');
}

function showSoComfirmation(){
    $.modal({
        open : 'so-confirmation',
        triggerOpen: true,
        type: 'notification'
    });
}

function submitNotifyMe(code, size, email, callback, sourceForTracking){
    var data = $.param({
        size : size,
        email : email,
        code : code,
        fw : true
    });

    $.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function(msg){
        if(callback){
            callback();
        }
        logEngagement(window.location.href,
            (sourceForTracking ? sourceForTracking + ' ' : '') + 'notify me',
            'submitted');
    });
}

function submitSpecialOrder(code, size, email, autoOrder, callback){

    var data = $.param({
        SOProductCode: code,
        SOSize: size,
        SOUserEmail: email,
        SOAutoOrder: autoOrder
    });
    $.post("/fw/SubmitSpecialOrderInquiry.jsp", data, function(){
        if(callback){
            callback();
        }
    });
}

function validateEmail(emailStr) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(emailStr);
}

function setUpBisAndSo(){
    $('.js-tabs').tabs();
    $('input[name="bis-size-options"], input[name="so-size-options"]').change(function(e){
        var el = $(this);
        var $form = el.closest('.tabs__content').length ? el.closest('form') : el.closest('.pdp__col');
        var isPDP = el.closest('.pdp__col').length;
        var $emailField = $form.find('.js-email-div');
        var instock = el.data('instock');
        var revolveInStock = el.data('revolve');
        var revolvePreorder = el.data('revolvePreorder');
        var preorder = el.data('preorder');
        var eligibleForSpecialOrder = el.data('eligibleForSpecialOrder');
        var isSpecialOrderForm = $(this).attr('name') === 'so-size-options';
        $('.notification').hide();

        var sizeLabel = $form.find('.js-size-selection-label');
        sizeLabel.removeClass("u-error");
        sizeLabel.removeClass("pdp__des-info--unselected");
        sizeLabel.html(el.data('size-label'));

        if(instock){
            $form.find('.js-notification-instock').show();
            $form.find('.notify-me__cta button').hide();
            $emailField.hide();
            $form.find('.notify-me__auto-order').hide();
            $form.find('.js-add-to-bag').show();
            manageElementsVisibility($form, isPDP);
        }else if(preorder){
            $form.find('.js-notification-preorder').show();
            $form.find('.notify-me__cta button').hide();
            $emailField.show();
            $form.find('.notify-me__auto-order').show();
            $form.find('.js-notify-me').show();
            manageElementsVisibility($form, isPDP);
        }else if(isSpecialOrderForm && !eligibleForSpecialOrder){
            $form.find('.js-notification-unavailable').show();
            $form.find('.notify-me__cta button').hide();
            $emailField.show();
            $form.find('.notify-me__auto-order').show();
            $form.find('.js-special-order').show();
            manageElementsVisibility($form, isPDP);
        }else if (!instock && (revolveInStock || revolvePreorder)) {
            $form.find('.js-notification-instock').hide();
            $form.find('.notify-me__cta button').hide();
            $emailField.hide();
            $form.find('.notify-me__auto-order').hide();
            $form.find('.js-add-to-bag').hide();
            $form.find('.js-notification-r-in-stock').show();
            $form.find('.js-shop-revolve-instock').show();
            if (isPDP) {
                $form.find('.js-oos-special-order').hide();
                $form.find('.js-oos-notify-me').show();
            }
            if (revolvePreorder) {
                $(".cross-site-preorder").removeClass('u-hide');
                $(".cross-site-shop").addClass("u-hide");
            } else {
                $(".cross-site-shop").removeClass("u-hide");
                $(".cross-site-preorder").addClass('u-hide');
            }
        }else{
            $form.find('.notify-me__cta button').hide();
            $emailField.show();
            $form.find('.notify-me__auto-order').show();
            manageElementsVisibility($form, isPDP);
            if(isSpecialOrderForm){
                $form.find('.js-special-order').show();
            }else{
                $form.find('.js-notify-me').show();
            }
        }
    });

    const notifyMeForms = $('.js-notify-me-form');
    notifyMeForms.unbind('submit').submit(function(e){
        e.preventDefault();
        var $form = $(this);
        var sizeLabel = $form.find('.js-size-selection-label');
        var hasError = false;
        const checkedInput = $form.find('input[name="bis-size-options"]:checked');
        if(checkedInput.length == 0){
            sizeLabel.html(sizeLabel.data('select-error-text'));
            sizeLabel.addClass("u-error");
            hasError = true;
        }
        var size = checkedInput.val();

        if(!isAddToBag($form)){
            var email = $form.find(':input[name="email"]').val();
            if(!validateEmail(email) || !email){
                $form.find(':input[name="email"]').closest('.field').addClass('is-error');
                hasError = true;
            }else{
                $form.find(':input[name="email"]').closest('.field').removeClass('is-error');
            }
        }

        if(hasError) return ;
        var code = $form.find(':input[name="code"]').val();
        if(isAddToBag($form)){
            //do add to bag
            addToBag(code, size);
        }else{
            //do notify me
            submitNotifyMe(code, size, email, function(){
                $('#bis-confirmation-email').html(email);
                $.modal({
                    open : 'bis-confirmation',
                    triggerOpen: true,
                    type: 'notification'
                });
            }, $form.data('embeddedPdp') ? 'embedded' : '')
        }
    });


    $('#special-order-form').submit(function(e){
        e.preventDefault();
        var $form = $(this);
        var hasError = false;
        var sizeLabel = $form.find('.js-size-selection-label');
        if($('input[name="so-size-options"]:checked').length == 0){
            sizeLabel.html(sizeLabel.data('select-error-text'));
            sizeLabel.addClass("u-error");
            hasError = true;
        } else {
            sizeLabel.removeClass("u-error")
        }
        var size = $('input[name="so-size-options"]:checked').val();

        if(!isAddToBag($form)){
            var emailField = $('#so-email');
            var email = emailField.val();
            if(!validateEmail(email)){
                emailField.closest('.field').addClass('is-error');
                hasError = true;
            }else{
                emailField.closest('.field').removeClass('is-error');
            }
        }


        if(hasError) return;
        var code = $form.find(':input[name="code"]').val();
        var autoOrder = $form.find('#so-auto-order').is(":checked");
        if(isAddToBag($form)){
            //do add to bag
            addToBag(code, size);
        }else if(isNotifyMe($form)){
            //do notify me
            submitNotifyMe(code, size, email, function(){
                $('#bis-confirmation-email').html(email);
                $.modal({
                    open : 'bis-confirmation',
                    triggerOpen: true,
                    type: 'notification'
                });
            })
        }else{
            //do special order
            var notEligible = $('.js-notification-unavailable').is(':visible');
            if(notEligible){
                submitSpecialOrder(code, size, email, autoOrder, function(){
                    submitNotifyMe(code, size, email, function(){
                        showSoComfirmation();
                    })
                });
            }else{
                submitSpecialOrder(code, size, email, autoOrder, function(){
                    showSoComfirmation();
                });
            }
        }
    });

    $('.js-shop-revolve-instock').on('click', function(event) {
        event.preventDefault();
        const sizeType = $(this).data('sizeType');
        let selectedSize;
        if (sizeType == 'so') {
            selectedSize = $('input[name="so-size-options"]:checked');
        } else {
            selectedSize = $('input[name="bis-size-options"]:checked');
        }

        if (selectedSize.length > 0) {
            const sizeValue = selectedSize.val();
            const productCode = $(this).data('code');
            const baseURL = $(this).data('href');
            const dynamicURL = baseURL + '&size=' + sizeValue + '&code=' + productCode;

            window.open(dynamicURL, '_blank');
        }
    });

    $('input[name="bis-size-options"]:checked').trigger('change');
    $('input[name="so-size-options"]:checked').trigger('change');
}

export default setUpBisAndSo;


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/bis-and-so.js